import { render, staticRenderFns } from "./VTd.vue?vue&type=template&id=08ae3f6e&"
import script from "./VTd.vue?vue&type=script&lang=ts&"
export * from "./VTd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports